/*
 * Per-user sync cache. sessionStorage only: it dies with the tab, is scoped to
 * the origin, and is never shared between users, which is what keeps a cached
 * snapshot from ever being shown to someone who lacks access to that repo.
 */
import type { RepoState } from '../types'

const PREFIX = 'f3i-viz:'
export const CACHE_TTL_MS = 5 * 60 * 1000

export function readCache(repo: string): RepoState | null {
  try {
    const raw = sessionStorage.getItem(PREFIX + repo)
    if (!raw) return null
    const state = JSON.parse(raw) as RepoState
    if (Date.now() - new Date(state.fetchedAt).getTime() > CACHE_TTL_MS) return null
    return state
  } catch {
    return null
  }
}

export function writeCache(repo: string, state: RepoState): void {
  try {
    sessionStorage.setItem(PREFIX + repo, JSON.stringify(state))
  } catch {
    /* quota or private mode: the app works fine without a cache */
  }
}

export function clearCache(): void {
  try {
    for (const key of Object.keys(sessionStorage)) if (key.startsWith(PREFIX)) sessionStorage.removeItem(key)
  } catch {
    /* ignore */
  }
}

const LAST_REPO = 'f3i-viz:last-repo'
export const readLastRepo = () => { try { return localStorage.getItem(LAST_REPO) } catch { return null } }
export const writeLastRepo = (repo: string) => { try { localStorage.setItem(LAST_REPO, repo) } catch { /* ignore */ } }
